import React, { useState, useEffect, useRef, Suspense } from 'react';
// import { connect, useDispatch } from 'react-redux';
import { EDUCATION_LINK, FINAL_RESUME, HEADING_LINK, MONTHS, NEXT_EDUCATION_LABEL, START_YEAR, NEXT_LABEL, NEXT_SKILLS_LABEL, NEXT_SUMMARY_LABEL, NEXT_WORKHISTORY_LABEL, SKILLS_LINK, WORKHISTORY_LINK } from '../../constants/constants';
import { Redirect } from 'react-router';
import DraftEditor from '../common/DraftEditor';
import ErrorValidator from '../../ErrorValidator';
import TickIcon from '../../images/tick.svg';
import CalendarIcon from "../../assets/images-new/icons/calender.svg";
import DatePicker from "react-datepicker";
// import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import GPTSuggestionPopup from '../common/GPTSuggestionPopup';
import ErrorIcon from '../common/ErrorIcon';
import { useResume } from '../../context/ResumeContext';
//import PhrasesPopup from '../common/PhrasesPopup';
const PhrasesPopup = React.lazy(() => import("../common/PhrasesPopup"));

const AddJob = props => {
  const job = props.data
  const {
    getFieldSuggestionId,
    showSuggestionPopup
  } = useResume();
  const currDate = Date.now();
  const currentYear = new Date().getFullYear();
  const errorStyle = { color: 'red', fontSize: '10px' }
  const validatorSet = {
    // job_title: { empty: "Please Enter Position" },
    // employer: { empty: "Please Enter a Company Name" },
    // description: { empty: "Please enter the work description" },
    // city: { empty: 'Please Enter City' },
    // state: { empty: 'Please Enter State' },
    // start_date: {
    //   // empty: "Please Enter Start Date",
    //   other5: {
    //     msg: "Please select start year to complete the date.",
    //     validator: val => {
    //       let startArr = (job.start_date).split(' ');
    //       // startDate = new Date(education.start_date);
    //       // endDate = new Date(education.end_date);
    //       // return ((!education.currently_studying && education.end_date.trim().length && (new Date(education.start_date)).getTime() >= (new Date(education.end_date)).getTime()) ? true : false)
    //       if (job.start_date.length && startArr.length == 1 && !(/\d{4}/).test(startArr[0])) {
    //         return true;
    //       }
    //     }
    //   },
    //   other1: {
    //     msg: "Start Date should be less then current date",
    //     validator: val => {
    //       // startDate = new Date(job.start_date);
    //       //return false for no error
    //       return job.start_date.length && currDate < (new Date(job.start_date)).getTime()
    //     }
    //   }
    // },
    // end_date: {
    //   // other1: {
    //   //   msg: "Please Enter End Date",
    //   //   validator: val => {
    //   //     return ((job.end_date == '' && !job.currently_working) ? true : false)
    //   //   }
    //   // },
    //   other4: {
    //     msg: "Please select End Year to complete the date.",
    //     validator: val => {
    //       let endArr = (job.end_date).split(' ');
    //       if (job.end_date.length && !job.currently_working && (endArr.length == 1 && !(/\d{4}/).test(endArr[0]))) {
    //         return true;
    //       }
    //     }
    //   },
    //   other2: {
    //     msg: "End Date should be greated then start date",
    //     validator: val => {
    //       // startDate = new Date(job.start_date);
    //       // endDate = new Date(job.end_date);
    //       return job.start_date.length && job.end_date.length && !job.currently_working && (new Date(job.start_date)).getTime() > (new Date(job.end_date)).getTime()
    //     }
    //   },
    //   other3: {
    //     msg: "End Date should be less then current date",
    //     validator: val => {
    //       // endDate = new Date(job.end_date);
    //       return job.end_date.length && !job.currently_working && currDate < (new Date(job.end_date)).getTime() 
    //     }
    //   }
    // }
  };
  //For error validations
  const vObj = new ErrorValidator(validatorSet);

  const [openList, setOpenList] = useState({ list: { start_month: false, start_year: false, end_month: false, end_year: false } });

  // const dispatch = useDispatch();
  const [error, setError] = useState({})
  //Flag is Do Next redirect
  const [redirectNext, setredirectNext] = useState(false)
  //Flag is Do Back redirect
  const [redirectBack, setredirectBack] = useState(false)
  //Shift label position
  const [checkField, setCheckField] = useState('');
  //Component asked to redirect, first validate
  const [redirectCall, setredirectCall] = useState(false)
  const [showAIPopup, setShowAIPopup] = useState(false);
  const [showPhrasePopUp, setShowPhrasePopUp] = useState(false);
  //Quick edit mode
  const QEM = props.enabled_tabs.includes('completed')
  const label = (l) => QEM ? NEXT_LABEL : l
  const rURL = (u) => QEM ? FINAL_RESUME : u
  const section_key = 'work_history';

  const mounted = useRef(false);

  useEffect(() => {
      mounted.current = true;
      return () => {
          mounted.current = false;
      };
  }, []);

  const errorExists = () => {
    let anyerror = [];
    Object.keys(error).map((key) => {
      if (error[key] != '')
        anyerror.push(key);
    });
    return anyerror.length > 0 ? true : false;
  }

  const validateForm = () => {
    //Always look for errors
    if (1 || !errorExists()) {
      let v = vObj.validateFields(job)
      // let v = validateFields();
      if (Object.keys(v).length == 0) {
        return true;
      } else {
        setError({ ...v });
        return false;
      }
    } else {
      return false;
    }
  }

  const removeError = (e) => {
    setError({ ...error, [e.target.name]: '' })
  }

  const showMarker = field => (
    job.hasOwnProperty(field) &&
    job[field].length &&
    job.hasOwnProperty('validated') &&
    job.validated.hasOwnProperty(field) &&
    job.validated[field]
  )

  const fieldFocus = (e,n) => {
    setCheckField(e.target.name);
    removeError(e);
    props.updateJob({ validated: { ...job.validated, [e.target.name]: false } }, props.id)
  }

  const fieldBlur = e => {
    setCheckField('');
    // const er = validateFields(e.target.name)
    props.reviewIt()
    props.updateJob({ validated: { ...job.validated, [e.target.name]: true } }, props.id)
    const er = vObj.validateFields(e.target.value, e.target.name)
    if (!Object.keys(er).length) {
    } else setError({ ...error, ...er });
  }

  const formatDate = raw => {
    let d = null, m, y
    //Only year found in case of linkedin profile upload
    if (/^\s*\d{4}/.test(raw.trim())) {
      m = 'January'
      y = raw.trim()
    } else[m, y] = raw.split(' ')
    const mm = MONTHS.indexOf(m) + 1
    raw.length && (d = new Date(`${y}-${mm.toString().length == 1 ? '0'.concat(mm) : mm}-02`))
    return d
  }

  const getYears = () => {
    let options = [];
    for (var i = currentYear; i >= START_YEAR; i--) {
      options.push(i);
    }
    return options;
  }

  const toggleDropDown = (key) => {
    setOpenList({ list: { [key]: !openList.list[key] } });
  }

  const updateStartDate = (type, value) => {
    getCompleteStartDate(type, value);
  }
  const updateEndDate = (type, value) => {
    getCompleteEndDate(type, value);
  }

  const emptyAiData = () => {
    const aidata = (localStorage.getItem('aidata') ? JSON.parse(localStorage.getItem('aidata')) : {});
    if(aidata.job){
      delete aidata.job;
      //localStorage.removeItem('aidata');
      localStorage.setItem('aidata', JSON.stringify(aidata));
    }
  }
  const _getFieldSuggestionId = (field) => {
    return  props?.review && getFieldSuggestionId('work_history',field, props.id);
  }
  const clickHandler = (element_id) => {
    showSuggestionPopup(element_id);
  };

  return (<div className="editor-form">
      <div className="form-row column-2">
        <div className="field-wrap" id={_getFieldSuggestionId('job_title')}>
          {/* <label htmlFor="job_title" className={`label${checkField == 'job_title' ? ' label-focus': '' }`}>Position Title  { props._hasReviewSuggestions(props.id, 'job_title') && <ErrorIcon onClick={() => clickHandler(_getFieldSuggestionId('job_title'))} />}</label> */}
          <input
            placeholder="Position Title"
            className={`validate ${ props._hasReviewSuggestions(props.id, 'job_title') && 'review-error'}`}
            type="text"
            name="job_title"
            value={job.job_title}
            onChange={(e) => {
              //removeError(e);
              props.updateJob({ job_title: e.target.value }, props.id);
            }}
            onFocus={(e) => fieldFocus(e)}
            onBlur={(e) => fieldBlur(e)}
          />
          {error.job_title && <span style={errorStyle}>{error.job_title}</span>}
        </div>
        <div className="field-wrap" id={_getFieldSuggestionId('employer')}>
          {/* <label htmlFor="employer" className={`label${checkField == 'employer' ? ' label-focus': '' }`}>Company Name { props._hasReviewSuggestions(props.id, 'employer') && <ErrorIcon onClick={() => clickHandler(_getFieldSuggestionId('employer'))} />}</label> */}
          <input
            placeholder="Company Name"
            className={`validate ${ props._hasReviewSuggestions(props.id, 'employer') && 'review-error'}`}
            type="text"
            name="employer"
            value={job.employer}
            onChange={(e) => {
              //removeError(e);
              props.updateJob({ employer: e.target.value }, props.id);
            }}
            onFocus={(e) => fieldFocus(e)}
            onBlur={(e) => fieldBlur(e)}
          />
          {error.employer && <span style={errorStyle}>{error.employer}</span>}
        </div>
      </div>
      <div className="form-row column-2">
        <div className="field-wrap">
          {/* <label htmlFor="city" className={`label${checkField == 'city' ? ' label-focus': '' }`}>City</label> */}
          <input
            placeholder="City"
            className="validate"
            type="text"
            name="city"
            value={job.city}
            onChange={(e) => {
              //removeError(e);
              props.updateJob({ city: e.target.value }, props.id);
            }}
            onFocus={(e) => fieldFocus(e)}
            onBlur={(e) => fieldBlur(e)}
          />
          {error.city && <span style={errorStyle}>{error.city}</span>}
        </div>
        <div className="field-wrap">
          {/* <label htmlFor="state" className={`label${checkField == 'state' ? ' label-focus': '' }`}>State</label> */}
          <input
            placeholder="State"
            className="validate"
            type="text"
            name="state"
            value={job.state}
            onChange={(e) => {
              //removeError(e);
              props.updateJob({ state: e.target.value }, props.id);
            }}
            onFocus={(e) => fieldFocus(e)}
            onBlur={(e) => fieldBlur(e)}
          />
          {error.state && <span style={errorStyle}>{error.state}</span>}
        </div>
      </div>
      <div className="form-row column-2">
        <div className="field-wrap date-field red"  id={_getFieldSuggestionId('start_date')}>
          {/* <label htmlFor="start_date" className={`label${checkField == 'start_date' ? ' label-focus': '' }`}>Start Date</label> */}
          <DatePicker
            placeholderText="Start Date"
            showMonthYearPicker
            value={formatDate(job.start_date)}
            selected={formatDate(job.start_date)}
            name="start_date"
            className={`form-input borderaccent custom-date-picker validate ${ props._hasReviewSuggestions(props.id, 'start_date') && 'review-error'}`}
            dateFormat="MMMM yyyy"
            onChange={(e) => {
              // e.getDate()
              // console.log(e)
              props.updateJob(
                { start_date: `${MONTHS[e.getMonth()]} ${e.getFullYear()}` },
                props.id
              );
              props.reviewIt()
            }}
            onFocus={(e) => fieldFocus(e)}
            onBlur={(e) => fieldBlur(e)}
            onChangeRaw={e => e.preventDefault()}
            autoComplete="off"
          />
          {error.start_date && <span style={errorStyle}>{error.start_date}</span>}
        </div>
        <div className="field-wrap date-field red" id={_getFieldSuggestionId('end_date')}>
          {/* <label className={`label${checkField == 'end_date' ? ' label-focus': '' }`} htmlFor="end_date">End Date { props._hasReviewSuggestions(props.id, 'end_date') && <ErrorIcon onClick={() => clickHandler(_getFieldSuggestionId('end_date'))} />}</label> */}

          {/* <CalendarIcon /> */}
          <DatePicker
            showMonthYearPicker
            placeholderText="End Date"
            value={formatDate(job.end_date)}
            selected={formatDate(job.end_date)}
            name="end_date"
            className={`form-input borderaccent custom-date-picker validate ${ props._hasReviewSuggestions(props.id, 'end_date') && 'review-error'}`}
            dateFormat="MMMM yyyy"
            disabled={job.currently_working ? "disabled" : ''}

            onChange={(e) => {
              setError({ ...error, end_date: '' })
              props.updateJob(
                { end_date: `${MONTHS[e.getMonth()]} ${e.getFullYear()}` },
                props.id
              );
              props.reviewIt()
            }}
            onFocus={(e) => { job.currently_working ? '' : fieldFocus(e) }}
            onBlur={(e) => fieldBlur(e)}
            onChangeRaw={e => e.preventDefault()}
            autoComplete="off"
          />
          {error.end_date && <span style={errorStyle}>{error.end_date}</span>}


        <div className={`on-off-btn${!job.currently_working ? ' disabled' : '' }`}>
          <p>
            <input
              type="checkbox"
              id="currentCompany"
              //checked={job.currently_working ? "checked" : ""}
              defaultChecked={job.currently_working ? 'checked' : ''}
              onChange={(e) => {
                props.updateJob(
                  { currently_working: e.target.checked, end_date: '' }, props.id
                );
                props.reviewIt()
              }}
            />
            <span><i></i></span> Currently Employed </p>
          </div>
        </div>
      </div>
      <div className="form-row" id={_getFieldSuggestionId('description')}>
        <div className="field-wrap">
          <label htmlFor="description" className="label editor-label">Work Summary  </label>

          {/* <label htmlFor="description" className="label editor-label">Work Summary { props._hasReviewSuggestions(props.id, 'description') && <ErrorIcon onClick={() => clickHandler(_getFieldSuggestionId('description'))} />} </label> */}
          {/* <p className="editor-subtitle">Get help writing your bullet points with the pre-written examples below.</p> */}
          <div className="rich-text-editor">
            <DraftEditor
              name="description"
              placeholder="e.g. Supported mentor teacher throughout lessons by preparing…"
              className={`validate ${ props._hasReviewSuggestions(props.id, 'description') && 'review-error'}`}
              textAlignment='left'
              value={job.description}
              //onChange={(e) => { props.updateJob({ description: e.target.value }, props.id) }}
              onInputChange={(val) => {
                props.updateJob({ description: val }, props.id);
              }}
              onBlur={() => props.reviewIt()}
            chatGptButton={true}
            phrasesButton={true}
            colorType="red"
              showAIPopup={showAIPopup}
              setShowAIPopup={(showAIPopup) => { setShowAIPopup(showAIPopup) }}
            showPhrasePopUp={showPhrasePopUp}
            setShowPhrasePopUp={(showPhrasePopUp) => { setShowPhrasePopUp(showPhrasePopUp) }}
            reviewEnabled={props?.review}
            reviewFieldParams = {{section: 'work_history', row_id: props.id, field: 'description'}}
            />
            {error.description && <span style={errorStyle}>{error.description}</span>}
            {showAIPopup 
              && <GPTSuggestionPopup 
                section="profession"
                phrase={job.job_title}
                id={props.id}
                data={job}
                updateAction={props.updateJob}
                setShowAIPopup={(a) => setShowAIPopup(a)}
              /> 
            }
          {showPhrasePopUp ? 
            <Suspense fallback={""}>
              <PhrasesPopup 
                section='work_history'
                phrase={job.job_title}
                id={props.id}
                data={job}
                updateAction={props.updateJob}
                setShowPhrasePopUp={(s) => setShowPhrasePopUp(s)}
              />
            </Suspense> : ''}
          </div>
        </div>
      </div>
  </div>);
}

export default AddJob;
